import aa from 'search-insights'
import { global } from './constants'

export const routeForRole = (role, person) => {
  const defaultPath = `/admin/org/people/${person.id}`

  if (!role) return defaultPath

  // Temporary until we reindex everything
  if (role.klass === 'Driver' && !role.site_id) {
    return `/admin/org/people/${person.id}`
  }

  // Check if organization uses customer dashboard for Client roles
  if (role.klass === 'Client') {
    return `/admin/org/clients/${person.client_slug}/dashboard`
  }

  const pathMap = {
    Volunteer: `/admin/org/volunteers/${role.id}/activity`,
    Attendee: `/admin/org/events/attendees/${role.id}`,
    Instructor: `/admin/org/events/instructors/${role.id}`,
    Driver: `/admin/org/sites/${role.site_id}/drivers/${role.id}`,
    Professional: defaultPath,
    Employee: defaultPath,
    'Client Contact': defaultPath,
    'Volunteer Contact': defaultPath
  }

  return pathMap[role.klass]
}

export const openProfilePage = (event, role, position, person, forceNewWindow = false) => {
  event.preventDefault()
  event.stopPropagation() // prevents parent <div> event handler from firing when <li> is clicked

  aa('clickedObjectIDsAfterSearch', {
    // sending click event to Algolia before re-directing
    userToken: global.userId,
    eventName: 'Search Result Clicked',
    index: global.indexName,
    queryID: person.queryId,
    objectIDs: [person.objectID],
    positions: [position]
  })

  const url = routeForRole(role, person)
  if (forceNewWindow || event.ctrlKey || event.metaKey) {
    window.open(url, '_blank')
  } else {
    window.location.pathname = url
  }
}
